import React from 'react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface StoreSummaryBooleanCellProps {
  value: boolean;
}

const StoreSummaryBooleanCell: React.FC<StoreSummaryBooleanCellProps> = ({ value }) =>
  value ? (
    <CheckRoundedIcon sx={{ color: '#34C759', fontSize: 18, verticalAlign: 'middle' }} />
  ) : (
    <CloseRoundedIcon sx={{ color: '#D32F2F', fontSize: 18, verticalAlign: 'middle' }} />
  );

export default React.memo(StoreSummaryBooleanCell);
